// The Driver's Log guide, admin screen (53_DriverLog.jsx · ModuleHelp, Max 01/11).
const en = {
  tabsT: 'The six tabs',
  tabsB: 'Overview shows each car\'s month, Daily entry is where a day is typed in, Places and Drivers & Cars are the lists, Gas price sets the fuel price, and Month close locks a month.',
  monthT: 'Pick the month',
  monthB: 'Use the arrows or the month box to move between months. The gas price used for that month is shown beside it.',
  carsT: 'One row per car',
  carsB: 'Days logged, days missing, km, fuel, overtime and cost per km for the month. Click a car to see its day-by-day table below.',
  daysT: 'The car\'s month, day by day',
  daysB: 'Every day of the month with the logged trip, km, fuel and overtime. Days not logged and weekends are shaded; click a day to correct it.',
  editT: 'Enter or edit for this car',
  editB: 'Opens the Daily entry tab on this car so you can add a day the driver forgot or fix one.',
  previewT: 'Driver view',
  previewB: 'Shows the screen exactly as the driver sees it on the phone, so you can check what they will be asked for. Nothing is saved from the preview.',
};
const ko = {
  tabsT: '여섯 개의 탭',
  tabsB: '개요는 차량별 한 달 현황, 일일 입력은 하루를 입력하는 곳, 장소와 운전기사 및 차량은 목록, 유가는 연료 단가 설정, 월 마감은 한 달을 잠그는 곳입니다.',
  monthT: '월 선택',
  monthB: '화살표나 월 입력칸으로 월을 이동합니다. 그 달에 적용된 유가가 옆에 표시됩니다.',
  carsT: '차량별 한 행',
  carsB: '그 달의 입력 일수, 누락 일수, km, 연료비, 초과근무, km당 비용입니다. 차량을 클릭하면 아래에 일별 표가 나옵니다.',
  daysT: '차량의 한 달, 일별',
  daysB: '그 달의 모든 날과 입력된 운행, km, 연료비, 초과근무가 나옵니다. 미입력일과 주말은 음영으로 표시되며, 날짜를 클릭해 수정합니다.',
  editT: '이 차량 입력/수정',
  editB: '이 차량으로 일일 입력 탭을 열어, 기사가 빠뜨린 날을 추가하거나 잘못된 날을 고칩니다.',
  previewT: '운전기사 화면',
  previewB: '운전기사가 휴대폰에서 보는 화면을 그대로 보여 주어 어떤 항목을 입력하게 되는지 확인할 수 있습니다. 미리보기에서는 아무것도 저장되지 않습니다.',
};
const vi = {
  tabsT: 'Sáu tab',
  tabsB: 'Tổng quan cho xem tháng của từng xe, Nhập liệu là nơi gõ từng ngày, Địa điểm và Tài xế & Xe là các danh sách, Giá xăng đặt giá nhiên liệu, Chốt tháng khóa một tháng lại.',
  monthT: 'Chọn tháng',
  monthB: 'Dùng mũi tên hoặc ô tháng để chuyển tháng. Giá xăng áp dụng cho tháng đó hiện ngay bên cạnh.',
  carsT: 'Mỗi xe một dòng',
  carsB: 'Số ngày đã nhập, số ngày thiếu, km, tiền xăng, tăng ca và chi phí mỗi km trong tháng. Bấm vào một xe để xem bảng từng ngày ở bên dưới.',
  daysT: 'Tháng của xe, từng ngày',
  daysB: 'Mọi ngày trong tháng kèm chuyến đã nhập, km, tiền xăng và tăng ca. Ngày chưa nhập và cuối tuần được tô màu; bấm vào một ngày để sửa.',
  editT: 'Nhập/sửa cho xe này',
  editB: 'Mở tab Nhập liệu cho xe này để bạn thêm ngày tài xế quên hoặc sửa một ngày.',
  previewT: 'Xem như tài xế',
  previewB: 'Hiện đúng màn hình tài xế thấy trên điện thoại, để bạn kiểm tra họ sẽ phải nhập những gì. Xem thử không lưu gì cả.',
};
const zh = {
  tabsT: '六个标签',
  tabsB: '总览显示每辆车的当月情况,每日录入用来输入某一天,地点和司机与车辆是列表,油价用来设置燃油价格,月结用来锁定一个月。',
  monthT: '选择月份',
  monthB: '用箭头或月份输入框切换月份。该月使用的油价显示在旁边。',
  carsT: '每辆车一行',
  carsB: '当月已录入天数、缺失天数、公里数、油费、加班以及每公里成本。点击一辆车,下方会显示它逐日的表格。',
  daysT: '该车当月逐日明细',
  daysB: '当月每一天及已录入的行程、公里数、油费和加班。未录入的日子和周末会有底色;点击某一天即可修改。',
  editT: '为这辆车录入/修改',
  editB: '打开这辆车的每日录入标签,可补上司机漏填的一天或修正某一天。',
  previewT: '司机视图',
  previewB: '显示司机在手机上看到的页面,方便你确认他们要填哪些内容。预览中不会保存任何数据。',
};
const dictionary = { ns: 'tourDriverLog', en, ko, vi, zh };
export default dictionary;
